/** Session cookie's name for the CSRF value */
export const CSRF_COOKIE_NAME = 'x-csrf-token';

/** Header's name for sending the CSRF value */
export const CSRF_HEADER_NAME = 'x-csrf-token';
